import Image1 from "../../images/SCREENSHOT/barbing .png";
import Image2 from "../../images/SCREENSHOT/bootstrap.png";
import Image3 from "../../images/SCREENSHOT/HERO HEADER PAGE.png";
import Image4 from "../../images/SCREENSHOT/ecommerce.png";
import Image5 from "../../images/SCREENSHOT/landing page.png";
import Image6 from "../../images/SCREENSHOT/pick a card.png";
import Image7 from "../../images/SCREENSHOT/recipe food.png";
import Image8 from "../../images/SCREENSHOT/movie cart.png";
import Image9 from "../../images/SCREENSHOT/engine.png";
import Image10 from "../../images/SCREENSHOT/imagecard.png";
import Image12 from "../../images/SCREENSHOT/innovation sch.jpg";
import Image13 from "../../images/SCREENSHOT/hairBookin.jpg";
import Image14 from "../../images/SCREENSHOT/real estate 1.jpg";
import Image15 from "../../images/SCREENSHOT/real estate 2.jpg";
import Image16 from "../../images/SCREENSHOT/care hospital.jpg";
import Image17 from "../../images/SCREENSHOT/friday temp1.jpg";
import Image18 from "../../images/SCREENSHOT/logistics 1.jpg";
import Image19 from "../../images/SCREENSHOT/flight 1.jpg";
import Image20 from "../../images/SCREENSHOT/resume Ai builder.jpg";
import Image21 from "../../images/SCREENSHOT/craftByIBK.png";
import Image22 from "../../images/SCREENSHOT/loanAPP.png";
import Image23 from "../../images/SCREENSHOT/estatePRO.png";
import Image24 from "../../images/SCREENSHOT/AdminFintechDasboard.png";
import Image25 from "../../images/SCREENSHOT/vellomiji .png";
import Image26 from "../../images/SCREENSHOT/magville.png";
import Image27 from "../../images/SCREENSHOT/maison .png";
import Image28 from "../../images/SCREENSHOT/BizPulse.png";

const PortfolioDataLink = [
  {
    id: "craft - by - ibk",
    category: "frontend",
    image: Image21,
    // title: "Project Title One (FRONTEND)1",
    title: "E-commerce Craft By IBK",
    description: " highlighting its main features and technologies used.",
    demo: "https://craftbyibk.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "vellomij-fintech",
    category: "frontend",
    image: Image25,
    // title: "Project Title One (FRONTEND)1",
    title: "VELLOMIJ FINTECH BANKING",
    description: "",
    demo: "https://vellomij-fintech-web-banking.vercel.app/landing",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "magville-hotel",
    category: "frontend",
    image: Image26,
    // title: "Project Title One (FRONTEND)1",
    title: "MAGVILLE HOTEL MANAGEMENT SYSTEM",
    description: "",
    demo: "https://magville-hotelepe-liveproject-demo.vercel.app",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "maison-bellz",
    category: "frontend",
    image: Image27,
    // title: "Project Title One (FRONTEND)1",
    title: "MAISON BELLZ VIEW",
    description: "Achietech World of ",
    demo: "https://maison-view.vercel.app",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "bizpulse-ai",
    category: "frontend",
    image: Image28,
    // title: "Project Title One (FRONTEND)1",
    title: "BIZPULSE AI SOLUTION",
    description: "Business Idea and solution with AI Support",
    demo: "https://biz-pulse-three.vercel.app",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "loan-application",
    category: "frontend",
    image: Image22,
    // title: "Project Title One (FRONTEND)1",
    title: "Loan Application",
    description:
      "A modern loan application built with React and Firebase, provide a seamless experience for users to apply for loans online.",
    demo: "https://loan-web-app-next-js-frontend.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "Admin-Fintech-Dashboard",
    category: "frontend",
    image: Image24,
    // title: "Project Title One (FRONTEND)1",
    title: "Admin Fintech Dashboard",
    description:
      "A modern admin dashboard for a fintech application built with React and Firebase, provide a seamless experience for users to manage their financial data.",
    demo: "https://vellomij-fintech-banking-admin-dash.vercel.app",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "EstatePRO",
    category: "frontend",
    image: Image23,
    // title: "Project Title One (FRONTEND)1",
    title: "EstatePRO",
    description:
      "EstatePRO highlighting its main features and technologies used.",
    demo: "https://estatepro-gamma.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "innovation-code",
    category: "frontend",
    image: Image12,
    // title: "Project Title One (FRONTEND)1",
    title: "Innovation Coding Academy",
    description:
      "Innovation Coding Academy highlighting its main features and technologies used.",
    demo: "https://frontend-heavy-task.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "the-barber",
    category: "frontend",
    image: Image13,
    // title: "Project Title One (FRONTEND)1",
    title: "The Barber Shop",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://hair-style-booking-app-frontend.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "real-estate-project",
    category: "frontend",
    image: Image14,
    // title: "Project Title One (FRONTEND)1",
    title: "Real Estate Project",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://real-estate-project-frontend-gilt.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "real-estate-project2",
    category: "frontend",
    image: Image15,
    // title: "Project Title One (FRONTEND)1",
    title: "The Real Estate Project",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://real-estate-project-frontend-gilt.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "the-clinic-care",
    category: "frontend",
    image: Image16,
    // title: "Project Title One (FRONTEND)1",
    title: "The Clinic Care Data Chart",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://coalition-technologies-frontend-task-w78s.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "belsoft-friday",
    category: "frontend",
    image: Image17,
    // title: "Project Title One (FRONTEND)1",
    title: "Belsoft Friday Temp",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://belsoft-system-onboarding-frontend-task.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "logistics-testing",
    category: "frontend",
    image: Image18,
    // title: "Project Title One (FRONTEND)1",
    title: "Logistics Testing",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://logistics-testing-frontend.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "google-flight",
    category: "frontend",
    image: Image19,
    // title: "Project Title One (FRONTEND)1",
    title: "Google Flight Demo App",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://google-flight-demo-app-w8z6.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },
  {
    id: "ai-resume",
    category: "frontend",
    image: Image20,
    // title: "Project Title One (FRONTEND)1",
    title: "AI Resume Builder",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://www.jobtumb.com/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "beauty-barber",
    category: "frontend",
    image: Image1,
    // title: "Project Title One (FRONTEND)1",
    title: "Beauty Barbing Salon",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://google.com",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "bootstrap-project",
    category: "frontend",
    image: Image2,
    // title: "Project Title One (FRONTEND)2",
    title: "Bootstrap Project",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://bello682.github.io/WEBSITE-BOOTSTRAP-CASHTOKEN/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "simple-hero",
    category: "backend",
    image: Image3,
    title: "Simple Hero Header Page",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://google.com",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "ecommerce-website",
    category: "frontend",
    image: Image4,
    // title: "Project Title One (FRONTEND)4",
    title: "Ecommerce Website",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://bello682.github.io/E-COM-APP-PROJECT-JAVASCRIPT/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "simple-design",
    category: "backend",
    image: Image5,
    // title: "Project Title One (BACKEND)5",
    title: "Simple Design Landing Page",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://google.com",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "pick-a-card",
    category: "frontend",
    image: Image6,
    // title: "Project Title One (FRONTEND)6",
    title: "Pick a Card Game",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://bello682.github.io/JAVASCRIPT-CHECK-GAME-PICK-RAMDOM-GAME-/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "food-recipe",
    category: "backend",
    image: Image7,
    // title: "Project Title One (BACKEND)7",
    title: "Food Recipe",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://bello682.github.io/Recipe-App-Javascript-/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "moview-hub",
    category: "frontend",
    image: Image8,
    // title: "Project Title One (FRONTEND)8",
    title: "Movie Hub",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://movie-search-app-blush-nu.vercel.app/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "engineer-web",
    category: "backend",
    image: Image9,
    // title: "Project Title One (BACKEND)9",
    title: "Engineering web",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://bello682.github.io/JAVASCRIPT-ENGINEERING-WEBSITE-APP/",
    github: "https://github.com/bello682?tab=repositories",
  },

  {
    id: "previewer-card",
    category: "frontend",
    image: Image10,
    title: "Previewer Card",
    description:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni nobis labore impedit ullam. ",
    demo: "https://google.com",
    github: "https://github.com/bello682?tab=repositories",
  },
];

export default PortfolioDataLink;
